import type { SecuritySettingsFeature } from '../types';

export const securitySettings: SecuritySettingsFeature = {
    alternateHandover: {
        enabled: true,
        _description: 'Opens Security Settings by using a new URL and targetClientId',
    },
};
